import IconQuestion24 from '@warp-ds/icons/react/question-24';
import { type FC, useState } from 'react';
import type { Agent, DeviceType } from '../agent';
import { useOnVisible } from '../hooks/useOnVisible';
import { PANEL_SHELL_CLASSNAME } from '../pristips/dimensions';
import { trackViewMeglerpromo } from '../utils/tracking';
import { MeglerpromoCarousel } from './MeglerpromoCarousel';

interface Props {
    agents: Agent[];
    squareMeterPrice: number | null;
    deviceType: DeviceType;
    searchParams: URLSearchParams;
}

export const MeglerpromoPanel: FC<Props> = ({ agents, squareMeterPrice, deviceType, searchParams }) => {
    const [infoOpen, setInfoOpen] = useState(false);
    const isMobile = deviceType === 'mobile';
    const sectionRef = useOnVisible<HTMLElement>(trackViewMeglerpromo);

    return (
        <section className={`${PANEL_SHELL_CLASSNAME} s-bg ${isMobile ? 'pb-24' : 'pb-16'}`} ref={sectionRef}>
            <header className="flex justify-between items-start pt-24 gap-8 px-24">
                <div className="flex flex-col gap-4 min-w-0">
                    <h3>Utvalgte meglere som har solgt i området</h3>
                </div>
                <button
                    type="button"
                    className="shrink-0 w-[28px] h-[28px] rounded-full border-[1.5px] s-border mt-4 s-text-subtle s-bg flex items-center justify-center cursor-pointer text-s font-normal"
                    aria-label="Mer informasjon"
                    aria-expanded={infoOpen}
                    onClick={() => setInfoOpen((open) => !open)}
                >
                    <IconQuestion24 />
                </button>
            </header>

            {infoOpen && (
                <div
                    className="absolute top-[52px] right-16 z-50 max-w-[320px] p-16 s-bg s-border rounded-8 shadow-s text-s s-text"
                    role="tooltip"
                >
                    Her ser du meglere som har solgt boliger i området du søker på de siste 6 månedene. Meglerne som
                    vises har kjøpt Stor Pakke på FINN og har aktivert Meglerprofil. Listen sorteres tilfeldig med lik
                    fordeling.
                </div>
            )}

            <div className="mt-8">
                <MeglerpromoCarousel
                    agents={agents}
                    squareMeterPrice={squareMeterPrice}
                    deviceType={deviceType}
                    searchParams={searchParams}
                />
            </div>
        </section>
    );
};
